import { useEffect, useState } from "react";
import { siteNav } from "@/mocks/chiGuaData";

function formatHeat(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
  return `${n}`;
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [heat, setHeat] = useState(186400);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setHeat((v) => v + Math.floor(Math.random() * 120) - 30);
    }, 3000);
    return () => window.clearInterval(timer);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <a
          href="#top"
          onClick={() => setOpen(false)}
          className="flex items-center gap-2 whitespace-nowrap"
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full font-heading text-lg font-black ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/95 text-primary-700"
            }`}
          >
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-black tracking-tight ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              吃瓜反差
            </span>
            <span
              className={`text-[10px] font-medium tracking-[0.22em] ${
                solid ? "text-foreground-500" : "text-background-200/90"
              }`}
            >
              CONTRAST ARCHIVE
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {siteNav.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                solid
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
                  : "text-background-100 hover:bg-background-50/10 hover:text-white"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <span
            className={`hidden items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold md:flex ${
              solid ? "bg-accent-100 text-accent-900" : "bg-background-50/15 text-accent-100"
            }`}
          >
            <i className="ri-fire-fill" />
            今日围观 {formatHeat(heat)}
          </span>
          <a
            href="#about"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold transition-colors sm:inline-flex ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-primary-700 hover:bg-white"
            }`}
          >
            我要围观
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-9 w-9 items-center justify-center rounded-md lg:hidden ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-white hover:bg-background-50/10"
            }`}
          >
            <i className={`ri-${open ? "close-line" : "menu-3-line"} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="mx-3 mb-3 rounded-xl border border-background-200/70 bg-background-50 p-2 lg:hidden">
          {siteNav.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={() => setOpen(false)}
              className="flex items-center justify-between rounded-lg px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-900"
            >
              {item.label}
              <i className="ri-arrow-right-s-line text-primary-500" />
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}